// extracted by mini-css-extract-plugin
export default {"navbarItem":"NavbarItem_navbarItem__R+DPa","active":"NavbarItem_active__OeVGq"};